// ==============================|| MAIN MENU ITEMS ||============================== //

const mainMenu = [
    {
      id: 'repositories',
      title: 'Archives',
      url: '/repositories',
      icon: 'database',
      activeUrls: ['/repositories', '/scenes']
    },
    {
      id: 'navigator',
      title: 'Navigator',
      url: '/navigator',
      icon: 'deployed_code',
     
    },
    {
      id: 'jobs-queue',
      title: 'Jobs Queue',
      url: '/jobs-queue',
      icon: 'description',
      
    },
    {
      id: 'point-tasking',
      title: 'Point Tasking',
      url: 'https://app.aetosky.com/aetos-browser/tasking-panel',
      icon: 'language',
      external: true,
    
    }
  ]


export default mainMenu



